import { render, staticRenderFns } from "./GroupsInput.vue?vue&type=template&id=260c7ebf&"
import script from "./GroupsInput.vue?vue&type=script&lang=ts&"
export * from "./GroupsInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports